export function getListById (lists, listId) {
	return lists.find(list => list.id === listId)
}

export function getListByTaskId (lists, taskId) {
	return lists.find(list => list.tasks.find(task => task.id === taskId))
}

export function getTaskById (lists, taskId) {
	const list = lists.find(list => list.tasks.find(task => task.id === taskId))
	if (list) {
		return list.tasks.find(task => task.id === taskId)
	}
}



// WEBPACK FOOTER //
// ./src/utils/board.js